import React from 'react';
import productImage from '../assets/SimVR2.webp'; // Adjust the path as necessary
import CallToAction from './CallToAction';
function Header() {
    return (
      <header className="App-header">
        <div className="container py-5">
            <h1 style={{ color: '#FFC943', fontWeight: 'bold', fontSize:'5vh'}}>SimVR</h1>
            <h2 className="mt-3">Haz tu inducción empresarial, de manera ágil, práctica y didáctica, con realidad virtual</h2>
          

<img src={productImage} alt="SimVR Product" />
            
            <h3>Transformación Digital en Capacitación</h3>
            <h3>Documente su proceso escrito a una Experiencia Inmersiva.</h3>
            <CallToAction text="Solicita una demostración" message="Quiero solicitar una demostración de SimVR" actionId="demo" />
        </div>
      </header>
    );
}
  
export default Header;